import React from 'react';
import styles from './TabletSidebar.module.scss';
import Button from 'component/atom/forms/button/Button';
import { SideBarState } from 'app-context/mobile-sidebar-state/MobileSibebar';

const TabletSidebar = () => {
  const { toggleState } = SideBarState();
  return (
    <Button
      type="burger-menu"
      className={styles['burger-menu']}
      onClick={toggleState}
    />
  );
};

export default TabletSidebar;
